<template>
  <div>
    <div>
      <a class="btn btn-default btn-block" @click="toggle">
        <i class="fa fa-fw" :class="{'fa-expand': !expanded, 'fa-compress': expanded}"></i>
        {{ title }}
      </a>
    </div>

    <div v-if="expanded">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['shown', 'hidden'],

  props: {
    initial: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Expand'
    },
  },

  data() {
    return {
      expanded: this.initial
    }
  },

  methods: {
    show() {
      this.expanded = true;
      this.$emit('shown', event);
    },

    hide() {
      this.expanded = false;
      this.$emit('hidden', event);
    },

    toggle() {
      if (this.expanded) {
        this.hide();
      } else {
        this.show();
      }
    },
  },

}
</script>
